import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffConfiguration = () => import('./staff/configuration')
const ViewStaffPriceListSuppliers = () => import('./staff/crudPriceListSuppliers')
const ViewStaffPriceListSuppliersImportLog = () => import('./staff/crudImportLog')
const ViewStaffPriceListSuppliersUpdateExternal = () => import('./staff/crudUpdateExternal')
const ViewStaffPriceListSuppliersImportEditor = () => import('./staff/crudImportEditor')
const ViewStaffProductSuppliersByBarcode = () => import('./staff/crudProductSuppliersByBarcode')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'CostsStaffDashboard',
  configuration: 'CostsStaffConfiguration',
  crudPriceListSuppliers: 'CostsStaffPriceListSuppliers',
  crudImportLog: 'CostsStaffPriceListSuppliersImportLog',
  crudImportEditor: 'CostsStaffPriceListSuppliersImportEditor',
  crudUpdateExternal: 'CostsStaffPriceListSuppliersUpdateExternal',
  crudProductSuppliersByBarcode: 'CostsStaffProductSuppliersByBarcode',
}

const router =
  [
    {
      path: '/st/costs',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos de Productos por Proveedor',
          }
        },
        {
          path: 'configuration',
          name: VIEWS.configuration,
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Configuración',
          }
        },
        {
          path: 'price-list-suppliers',
          name: VIEWS.crudPriceListSuppliers,
          component: ViewStaffPriceListSuppliers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de productos por proveedor',
          }
        },      
        {
          path: 'price-list-suppliers-import-log',
          name: VIEWS.crudImportLog,
          component: ViewStaffPriceListSuppliersImportLog,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Log de Importación',
          }                    
        },                
        {
          path: 'price-list-suppliers-import-editor',
          name: VIEWS.crudImportEditor,
          component: ViewStaffPriceListSuppliersImportEditor,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Editor de Importación',
          }                    
        },                
        {
          path: 'price-list-suppliers-update-external',
          name: VIEWS.crudUpdateExternal,
          component: ViewStaffPriceListSuppliersUpdateExternal,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Actualización Externa',
          }          
        },
        {
          path: 'product-suppliers-by-barcode',
          name: VIEWS.crudProductSuppliersByBarcode,
          component: ViewStaffProductSuppliersByBarcode,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Gestion de Productos',
          }
        },
      ]
    },

    {
      path: '/cu/costs',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/costs',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
